import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  Button,
  IconButton,
  Stack,
  TableContainer,
  Avatar,
} from '@mui/material'
import { Box } from '@mui/system'
import DeleteIcon from '@mui/icons-material/Delete'
import EditIcon from '@mui/icons-material/Edit'
import CreateNoteDialog from './CreateNoteDialog'
import AddIcon from '@mui/icons-material/Add'
import EditNoteDialog from './EditNoteDialog.js'
import VisibilityIcon from '@mui/icons-material/Visibility'
import ShowNoteDialog from './ShowNoteDialog.js'
import moment from 'moment'
import DeleteNoteDialog from './DeleteNoteDialog'
import InfoIcon from '@mui/icons-material/Info'

const Notes = ({ data, onNotesChanged }) => {
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(5)
  const [openEditNote, setOpenEditNote] = useState(false)
  const [openCreateNote, setOpenCreateNote] = useState(false)
  const [openShowNote, setOpenShowNote] = useState(false)
  const [openDeleteNote, setOpenDeleteNote] = useState(false)
  const [currentNote, setCurrentNote] = useState()
  const start = page * rowsPerPage
  const end = page * rowsPerPage + rowsPerPage
  const count = data?.length || 0
  const [notes, setNotes] = useState(data || [])

  useEffect(() => {}, [notes])

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const handleCreate = async (note) => {
    notes.push(note)
    setNotes(notes)
    onNotesChanged(notes)
    setOpenCreateNote(false)
  }

  const handleClickCreate = async () => {
    setOpenCreateNote(true)
  }

  const handleClickShowNote = (note) => {
    setCurrentNote(note)
    setOpenShowNote(true)
  }

  const handleClickEditNote = (note) => {
    setCurrentNote(note)
    setOpenEditNote(true)
  }

  const handleClickDeleteNote = (note) => {
    setCurrentNote(note)
    setOpenDeleteNote(true)
  }

  const handleDelete = (note) => {
    const newNotes = notes.filter((item) => item.id !== note.id)
    setNotes(newNotes)
    onNotesChanged(newNotes)
    setOpenDeleteNote(false)
  }

  const handleCloseDeleteNote = async () => {
    setOpenDeleteNote(false)
  }
  const handleCloseShowNote = async () => {
    setOpenShowNote(false)
  }

  const handleCloseCreateNote = async () => {
    setOpenCreateNote(false)
  }

  const handleCloseEditNote = async () => {
    setOpenEditNote(false)
  }

  const handleEdit = (note) => {
    const newNotes = notes.map((item) => (note.id == item.id ? note : item))
    setNotes(newNotes)
    onNotesChanged(newNotes)
    setOpenEditNote(false)
  }

  const getNotesPaginatedAndSortedByCreatedAt = () => {
    return notes
      .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
      .slice(start, end)
      .map((note, index) => renderTableRow(note, index))
  }

  const renderTableRow = (note) => {
    return (
      <TableRow>
        <TableCell>
          <Box
            sx={{
              maxWidth: '100%',
              display: '-webkit-box',
              WebkitBoxOrient: 'vertical',
              WebkitLineClamp: 1,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {note?.content ?? '-'}
          </Box>
        </TableCell>
        <TableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}>
          <Avatar alt={note?.created_by ?? '-'}>{note?.created_by?.slice(0, 2).toUpperCase() ?? ''}</Avatar>
        </TableCell>
        <TableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}>
          {note.created_at ? moment(note.created_at).format('L LT') : '-'}
        </TableCell>
        <TableCell>
          <Stack direction="row" spacing={1}>
            <IconButton color="primary" onClick={() => handleClickShowNote(note)}>
              <VisibilityIcon />
            </IconButton>
            <IconButton color="primary" onClick={() => handleClickEditNote(note)}>
              <EditIcon />
            </IconButton>
            <IconButton color="primary" onClick={() => handleClickDeleteNote(note)}>
              <DeleteIcon />
            </IconButton>
          </Stack>
        </TableCell>
      </TableRow>
    )
  }

  return (
    <Box sx={{ width: '100%', overflow: 'hidden' }}>
      <div style={{ display: 'flex' }}>
        <Button
          size="small"
          variant="outlined"
          onClick={handleClickCreate}
          style={{ marginLeft: 'auto' }}
          startIcon={<AddIcon />}
        >
          Add
        </Button>
      </div>
      {notes.length > 0 ? (
        <>
          <TableContainer>
            <Table stickyHeader size="small">
              <TableHead>
                <TableRow>
                  <TableCell width="65%">{'Note'}</TableCell>
                  <TableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}>{'Created by'}</TableCell>
                  <TableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}>{'Created at'}</TableCell>
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody>{getNotesPaginatedAndSortedByCreatedAt()}</TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={count}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </>
      ) : (
        <Typography align="center">
          <InfoIcon /> No Notes available
        </Typography>
      )}
      <ShowNoteDialog open={openShowNote} onClose={handleCloseShowNote} note={currentNote} />
      <EditNoteDialog open={openEditNote} onClose={handleCloseEditNote} onEdit={handleEdit} note={currentNote} />
      <CreateNoteDialog open={openCreateNote} onClose={handleCloseCreateNote} onCreate={handleCreate} />
      <DeleteNoteDialog open={openDeleteNote} onClose={handleCloseDeleteNote} onDelete={handleDelete} note={currentNote} />
    </Box>
  )
}

Notes.propTypes = {
  data: PropTypes.array,
  props: PropTypes.object,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
}

export default Notes
